import { ListItemContent, ListItemContentProps } from "@datamole/wds-component-list";
import { forwardRef } from "react";

type Props = ListItemContentProps;

const ItemContent = forwardRef<HTMLDivElement, Props>((props, ref) => <ListItemContent {...props} ref={ref} />);

ItemContent.displayName = "Menu.Content.Item.Content";

export { ItemContent as MenuContentItemContent };
export type { Props as MenuContentItemContentProps };
